import { render } from "./EditName.vue?vue&type=template&id=61e838fa&scoped=true"
import script from "./EditName.vue?vue&type=script&setup=true&lang=js"
export * from "./EditName.vue?vue&type=script&setup=true&lang=js"

import "./EditName.vue?vue&type=style&index=0&id=61e838fa&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61e838fa"],['__file',"resources/js/modules/product-mapping-tool/components/EditName.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "61e838fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('61e838fa', __exports__)) {
    api.reload('61e838fa', __exports__)
  }
  
  module.hot.accept("./EditName.vue?vue&type=template&id=61e838fa&scoped=true", () => {
    api.rerender('61e838fa', render)
  })

}


export default __exports__